export default __webpack_public_path__ + "search-examples-uitextfield-search-1200-949e619238dd1d5e804e07b3df73999b.png";